import { render } from "./crumbs.vue?vue&type=template&id=2d55187d"
import script from "./crumbs.vue?vue&type=script&lang=js"
export * from "./crumbs.vue?vue&type=script&lang=js"

import "./crumbs.vue?vue&type=style&index=0&id=2d55187d&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/search-result/template4/components/crumbs.vue'],['render',render],['__file',"crumbs.vue"]])

export default __exports__